import useWooPluginUpdateV2 from "./definitions/useWooPluginUpdateV2";

// ─────────────────────────────────────────────────────────────────────────────
// Registro de anuncios post-login, en orden de prioridad (el host muestra
// SOLO el primero elegible por sesión; el siguiente aparece en el próximo
// login cuando el anterior fue descartado).
//
// Para agregar un anuncio nuevo (ej. "integración Shopify disponible"):
//   1. Crea `definitions/useShopifyDisponible.jsx`: un hook que recibe el
//      contexto compartido `{ user, isClient, integrations }` y devuelve
//      null (no elegible) o `{ id, title, steps, cta }`. El `id` debe ser
//      único y estable: es la clave del "no volver a mostrar" en localStorage.
//   2. Impórtalo y agrégalo a este arreglo.
//   3. Nada más: el AnnouncementsHost y el AnnouncementModal hacen el resto
//      (carrusel, puntos, checkbox de descarte, CTA).
//
// REGLA (Rules of Hooks): este arreglo debe ser ESTÁTICO — el host itera y
// llama cada hook incondicionalmente en cada render; nunca lo armes dinámico.
// La elegibilidad se decide DENTRO de cada hook devolviendo null.
// ─────────────────────────────────────────────────────────────────────────────

export const ANNOUNCEMENT_HOOKS = [useWooPluginUpdateV2];
